import { useMutation } from "react-query";

import URL from "core/resources/urls";
import http from "infra/http";

export default function useUnlinkJobsOnGroups() {
  return useMutation({
    mutationKey: ["unlink-jobs-on-groups"],
    mutationFn: async ({
      recurringJobGroupId,
      jobIds,
    }: {
      recurringJobGroupId: string;
      jobIds: string[];
    }) => {
      const body = {
        recurringJobGroupId: recurringJobGroupId,
        jobIds: jobIds,
      };

      const response = await http.delete<any, any>(
        `${URL.RECURRING_JOB_GROUP.UNLINK_JOBS_ON_GROUPS(recurringJobGroupId)}`,
        {
          data: body,
        },
      );

      return response;
    },
  });
}
